(function () {
  var CACHE_KEY = 'ed_fx_rates';
  var CACHE_TTL = 3600 * 1000; // 1 hour

  // Country ISO 3166-1 alpha-2 → { code: currency ISO, symbol: currency symbol }
  var COUNTRY_CURRENCY = {
    AF: { code: 'AFN', symbol: '؋' },
    AL: { code: 'ALL', symbol: 'L' },
    AM: { code: 'AMD', symbol: '֏' },
    AO: { code: 'AOA', symbol: 'Kz' },
    AR: { code: 'ARS', symbol: '$' },
    AU: { code: 'AUD', symbol: 'A$' },
    AZ: { code: 'AZN', symbol: '₼' },
    BA: { code: 'BAM', symbol: 'KM' },
    BD: { code: 'BDT', symbol: '৳' },
    BG: { code: 'BGN', symbol: 'лв' },
    BH: { code: 'BHD', symbol: 'BD' },
    BO: { code: 'BOB', symbol: 'Bs.' },
    BR: { code: 'BRL', symbol: 'R$' },
    BY: { code: 'BYN', symbol: 'Br' },
    CA: { code: 'CAD', symbol: 'CA$' },
    CH: { code: 'CHF', symbol: 'Fr' },
    CL: { code: 'CLP', symbol: '$' },
    CN: { code: 'CNY', symbol: '¥' },
    CO: { code: 'COP', symbol: '$' },
    CR: { code: 'CRC', symbol: '₡' },
    CZ: { code: 'CZK', symbol: 'Kč' },
    DK: { code: 'DKK', symbol: 'kr' },
    DO: { code: 'DOP', symbol: 'RD$' },
    DZ: { code: 'DZD', symbol: 'DA' },
    EG: { code: 'EGP', symbol: 'E£' },
    // Eurozone countries
    AT: { code: 'EUR', symbol: '€' },
    BE: { code: 'EUR', symbol: '€' },
    CY: { code: 'EUR', symbol: '€' },
    DE: { code: 'EUR', symbol: '€' },
    EE: { code: 'EUR', symbol: '€' },
    ES: { code: 'EUR', symbol: '€' },
    FI: { code: 'EUR', symbol: '€' },
    FR: { code: 'EUR', symbol: '€' },
    GR: { code: 'EUR', symbol: '€' },
    HR: { code: 'EUR', symbol: '€' },
    IE: { code: 'EUR', symbol: '€' },
    IT: { code: 'EUR', symbol: '€' },
    LT: { code: 'EUR', symbol: '€' },
    LU: { code: 'EUR', symbol: '€' },
    LV: { code: 'EUR', symbol: '€' },
    ME: { code: 'EUR', symbol: '€' },
    MT: { code: 'EUR', symbol: '€' },
    NL: { code: 'EUR', symbol: '€' },
    PT: { code: 'EUR', symbol: '€' },
    SI: { code: 'EUR', symbol: '€' },
    SK: { code: 'EUR', symbol: '€' },
    //
    GB: { code: 'GBP', symbol: '£' },
    GE: { code: 'GEL', symbol: '₾' },
    GH: { code: 'GHS', symbol: '₵' },
    GT: { code: 'GTQ', symbol: 'Q' },
    HK: { code: 'HKD', symbol: 'HK$' },
    HN: { code: 'HNL', symbol: 'L' },
    HU: { code: 'HUF', symbol: 'Ft' },
    ID: { code: 'IDR', symbol: 'Rp' },
    IL: { code: 'ILS', symbol: '₪' },
    IN: { code: 'INR', symbol: '₹' },
    IQ: { code: 'IQD', symbol: 'IQD' },
    IS: { code: 'ISK', symbol: 'kr' },
    JM: { code: 'JMD', symbol: 'J$' },
    JO: { code: 'JOD', symbol: 'JD' },
    JP: { code: 'JPY', symbol: '¥' },
    KE: { code: 'KES', symbol: 'KSh' },
    KG: { code: 'KGS', symbol: 'с' },
    KH: { code: 'KHR', symbol: '៛' },
    KR: { code: 'KRW', symbol: '₩' },
    KW: { code: 'KWD', symbol: 'KD' },
    KZ: { code: 'KZT', symbol: '₸' },
    LB: { code: 'LBP', symbol: 'LL' },
    LK: { code: 'LKR', symbol: 'Rs' },
    MA: { code: 'MAD', symbol: 'MAD' },
    MD: { code: 'MDL', symbol: 'L' },
    MK: { code: 'MKD', symbol: 'ден' },
    MM: { code: 'MMK', symbol: 'K' },
    MN: { code: 'MNT', symbol: '₮' },
    MX: { code: 'MXN', symbol: 'MX$' },
    MY: { code: 'MYR', symbol: 'RM' },
    NG: { code: 'NGN', symbol: '₦' },
    NO: { code: 'NOK', symbol: 'kr' },
    NP: { code: 'NPR', symbol: 'Rs' },
    NZ: { code: 'NZD', symbol: 'NZ$' },
    OM: { code: 'OMR', symbol: 'OMR' },
    PA: { code: 'PAB', symbol: 'B/.' },
    PE: { code: 'PEN', symbol: 'S/.' },
    PH: { code: 'PHP', symbol: '₱' },
    PK: { code: 'PKR', symbol: 'Rs' },
    PL: { code: 'PLN', symbol: 'zł' },
    PY: { code: 'PYG', symbol: '₲' },
    QA: { code: 'QAR', symbol: 'QR' },
    RO: { code: 'RON', symbol: 'lei' },
    RS: { code: 'RSD', symbol: 'din' },
    RU: { code: 'RUB', symbol: '₽' },
    SA: { code: 'SAR', symbol: 'SR' },
    SE: { code: 'SEK', symbol: 'kr' },
    SG: { code: 'SGD', symbol: 'S$' },
    TH: { code: 'THB', symbol: '฿' },
    TJ: { code: 'TJS', symbol: 'SM' },
    TN: { code: 'TND', symbol: 'TND' },
    TR: { code: 'TRY', symbol: '₺' },
    TT: { code: 'TTD', symbol: 'TT$' },
    TW: { code: 'TWD', symbol: 'NT$' },
    TZ: { code: 'TZS', symbol: 'TSh' },
    UA: { code: 'UAH', symbol: '₴' },
    UG: { code: 'UGX', symbol: 'USh' },
    UY: { code: 'UYU', symbol: '$U' },
    UZ: { code: 'UZS', symbol: 'soʻm' },
    VN: { code: 'VND', symbol: '₫' },
    YE: { code: 'YER', symbol: 'YR' },
    ZA: { code: 'ZAR', symbol: 'R' },
    ZM: { code: 'ZMW', symbol: 'ZK' }
  };

  function getSelectedCurrency() {
    var meta = document.querySelector('meta[name="ed-selected-currency"]');
    if (!meta) return null;
    var countryCode = (meta.getAttribute('content') || '').trim().toUpperCase();
    if (!countryCode || countryCode === 'US' || countryCode === '') return null;
    var entry = COUNTRY_CURRENCY[countryCode];
    if (!entry || entry.code === 'USD') return null;
    return { code: entry.code, symbol: entry.symbol };
  }

  function getCachedRates() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (cached && Date.now() - cached.ts < CACHE_TTL) return cached.rates;
    } catch (e) {}
    return null;
  }

  function cacheRates(rates) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rates: rates, ts: Date.now() }));
    } catch (e) {}
  }

  function fetchRates(cb) {
    var cached = getCachedRates();
    if (cached) { cb(cached); return; }
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.rates) { cacheRates(data.rates); cb(data.rates); }
      })
      .catch(function () {});
  }

  function fmtLocal(usdCents, rate, symbol, code) {
    var local = (usdCents / 100) * rate;
    var rounded = Math.round(local);
    return symbol + rounded.toLocaleString() + ' ' + code;
  }

  function fmtUSD(usdCents) {
    var usd = usdCents / 100;
    return '$' + usd.toFixed(2);
  }

  // ---------- PRODUCT PAGE ----------
  function applyProductPrice(rates, currency) {
    var containers = document.querySelectorAll('.price-savings-container[data-usd-cents]');
    containers.forEach(function (container) {
      var cents = parseInt(container.getAttribute('data-usd-cents'), 10);
      if (isNaN(cents)) return;
      var rate = rates[currency.code];
      if (!rate) return;

      var existing = container.querySelector('.ed-dual-price');
      if (existing) existing.remove();

      var block = document.createElement('div');
      block.className = 'ed-dual-price';
      block.innerHTML =
        '<span class="ed-dual-price__local">' + fmtLocal(cents, rate, currency.symbol, currency.code) + '</span>' +
        '<span class="ed-dual-price__usd">' + fmtUSD(cents) + ' USD (charged)</span>';

      var totalPrice = container.querySelector('.total-price');
      if (totalPrice) totalPrice.prepend(block);
    });
  }

  // ---------- CART PAGE ----------
  function applyCartNotice(rates, currency) {
    var subtotalEl = document.querySelector('[data-subtotal][data-cart-total-cents]');
    if (!subtotalEl) return;
    var cents = parseInt(subtotalEl.getAttribute('data-cart-total-cents'), 10);
    if (isNaN(cents) || cents <= 0) return;
    var rate = rates[currency.code];
    if (!rate) return;

    var existing = document.querySelector('.ed-cart-currency-notice');
    if (existing) existing.remove();

    var notice = document.createElement('div');
    notice.className = 'ed-cart-currency-notice';
    notice.innerHTML =
      '<div class="ed-cart-currency-notice__local">' +
        '<span class="ed-cart-currency-notice__label">Est. total (' + currency.code + '):</span>' +
        '<span class="ed-cart-currency-notice__amount">' + fmtLocal(cents, rate, currency.symbol, currency.code) + '</span>' +
      '</div>' +
      '<div class="ed-cart-currency-notice__usd">' +
        '&#9888; Your card will be charged in <strong>USD (' + fmtUSD(cents) + ')</strong>' +
      '</div>';

    subtotalEl.closest('.cart__item-sub').after(notice);
  }

  function apply(rates, currency) {
    applyProductPrice(rates, currency);
    applyCartNotice(rates, currency);
  }

  function init() {
    var currency = getSelectedCurrency();
    if (!currency) return;
    fetchRates(function (rates) { apply(rates, currency); });
  }

  // Re-apply after variant change (dispatched from ed-main-product.js)
  document.addEventListener('ed:priceUpdated', function (e) {
    var currency = getSelectedCurrency();
    if (!currency) return;
    var container = document.querySelector('.price-savings-container');
    if (container && e.detail && e.detail.cents) {
      container.setAttribute('data-usd-cents', e.detail.cents);
    }
    var cached = getCachedRates();
    if (cached) apply(cached, currency);
    else fetchRates(function (rates) { apply(rates, currency); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
